import { render } from "./LoginRegisterPage.vue?vue&type=template&id=c24aa85e&scoped=true"
import script from "./LoginRegisterPage.vue?vue&type=script&lang=js"
export * from "./LoginRegisterPage.vue?vue&type=script&lang=js"

import "./LoginRegisterPage.vue?vue&type=style&index=0&id=c24aa85e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24aa85e"]])

export default __exports__